export default {
    user: {
        create: {
            title: "Novo usuário",
            model: {
                email: {
                    label: "E-mail",
                    placeholder: "Preencha o e-mail"
                },
                name: {
                    label: "Nome",
                    placeholder: "Preencha o nome"
                },
                country: {
                    label: "País",
                    placeholder: "Preencha o país"
                },
                approval_manager_email: {
                    label: "E-mail do gerente",
                    placeholder: "Preencha o e-mail do gerente",
                    errors: {
                        different: "O e-mail do gerente de aprovação precisa ser diferente do e-mail do usuário"
                    }
                }
            },
            cta: {
                submit: {
                    text: "Enviar",
                    processing: "Enviando"
                },
                cancel: {
                    text: "Cancelar"
                }
            }
        }
    }
}